export const ApplicantDocumentTypeConstants = {
  FULL_BODY_PHOTO: 1,
  FACIAL_PHOTO: 2,
  VETERAN_ELIGIBILITY_DOCUMENT: 3,
  EDUCATION_DOCUMENT: 4,
  LAYOFF_NOTIFICATION_DOCUMENT: 5,
  COURT_MARTIAL_DOCUMENT: 6,
  MILITARY_DISCRAGE_DOCUMENT: 7,
  SELECTIVE_SERVICE_REGISTRATION_PROOF: 8,
  MILITARY_DD_214_FORM: 9,
  OTHER_NAME_DOCUMENT: 10,
  MARRIAGE_CERTIFICATE_DOCUMENT: 11,
  DIVORCE_DECREE_DOCUMENT: 12,
  ARREST_REPORT_DOCUMENT: 13,
  ARREST_COURT_REPORT_DOCUMENT: 14,
  BANKRUPTCY_DOCUMENT: 15,
  DRIVING_RECORD_PREVIOUS: 16,
  DRIVING_LICENSE_DOCUMENT: 67,
  DRIVING_RECORD_CURRENT: 65,
  LAW_ENFORCEMENT_TRAINING_CERTIFICATE: 17,
  BIRTH_OR_NATURALIZATION_CERTIFICATE: 18,
  LAW_ENFORCEMENT_DISCIPLINARY_ACTION: 43,
  SOCIAL_SECURITY_CARD: 62,
  EDUCATION_HS_DIPLOMA_DOCUMENT: 57,
  EDUCATION_MASTERS_DOCUMENT: 69,
}
